import { render, staticRenderFns } from "./phenviron.vue?vue&type=template&id=c8b19c92"
import script from "./phenviron.vue?vue&type=script&lang=js"
export * from "./phenviron.vue?vue&type=script&lang=js"
import style0 from "./phenviron.vue?vue&type=style&index=0&id=c8b19c92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports